module.exports = __webpack_public_path__ + "img/GreenGreenDoubleCircle400.a5902283.png";